import { Controller, useFormContext } from "react-hook-form";
import { Checkbox, CheckboxProps, Form } from "rsuite";

interface Props extends CheckboxProps {
  name: string;
  label?: string;
}

const CheckboxInput = ({ name, label, ...rest }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Form.Group controlId={name}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Checkbox
            {...rest}
            id={field.name}
            checked={field.value || false}
            onChange={(_value, checked) => {
              field.onChange(checked);
            }}
          >
            {label}
          </Checkbox>
        )}
      />
      <Form.ErrorMessage
        show={!!errors[name]}
        placement="bottomStart"
        className="text-wrap w-full"
      >
        <span className="text-wrap">
          {String(errors[name]?.message) || "This field is required"}
        </span>
      </Form.ErrorMessage>
    </Form.Group>
  );
};

export default CheckboxInput;
